import * as React from 'react'
import { IconButton } from '@doordash/component-button'
import { Text, Stack } from '@doordash/design-language'

import { ErrorPageContainer, Center, TextLink } from './styles'

import { ANDROID_CLOSE_DEEPLINK, IOS_CLOSE_DEEPLINK } from '../../../constants'
import { goToDeepLink } from '../../organisms/delivery-issues/utilities'

import t from './strings'

type ErrorProps = {
  shouldShowDismiss?: boolean
}

const handleRefresh = (e: React.MouseEvent<HTMLElement>) => {
  e.stopPropagation()
  window.location.reload(true)
}

export const ErrorPage = (props: ErrorProps) => (
  <ErrorPageContainer>
    <Center>
      <IconButton
        accessibilityLabel={t.refreshAction()}
        isRaised
        type={IconButton.Types.Primary}
        size={IconButton.Sizes.Large}
        iconType={IconButton.IconTypes.WarningTriangleFill}
        onClick={handleRefresh}
      />
      <Text>{t.title()}</Text>

      <Stack size={Stack.Sizes.XLarge}>
        <TextLink onClick={handleRefresh}>{t.refreshAction()}</TextLink>
      </Stack>
      {((typeof props.shouldShowDismiss === 'undefined') || (props.shouldShowDismiss === null) || (props.shouldShowDismiss === true)) && (
        <TextLink
        onClick={() =>
          goToDeepLink({
            ios: IOS_CLOSE_DEEPLINK,
            android: ANDROID_CLOSE_DEEPLINK,
          })
        }
        >
        {t.dismissAction()}
      </TextLink>
      )}
    </Center>
  </ErrorPageContainer>
)

export default ErrorPage
